import { DataArray, IDataArray } from './../../shared/index';
import { Minesite } from './../index';

export class Company implements IDataArray {
    public Id: number;
    public Name: string;
    public Active: boolean;
    public LastModified: Date;
    public Live: boolean;
    public Status: number;
    public Associated_ID: number;
    public Minesites: DataArray<Minesite> = new DataArray<Minesite>(1);
    public GetById(): number {
        return this.Id != undefined ? this.Id : 0;
    }
}
